/**
 * Validação de e-mail alinhada à RFC 5322 (parte local) e RFC 5321 (limites).
 *
 * Parte local (antes do @):
 *  - letras (A-Z, a-z) e números (0-9);
 *  - caracteres especiais: ! # $ % & ' * + - / = ? ^ _ ` { | } ~
 *  - ponto (.) como separador, desde que não seja o primeiro nem o último
 *    caractere e não haja pontos consecutivos.
 *
 * Domínio (depois do @):
 *  - rótulos com letras, números e hífen, sem iniciar ou terminar com hífen;
 *  - pelo menos um ponto separando os rótulos, sem pontos consecutivos;
 *  - domínio de topo (TLD) com 2 a 63 letras.
 *
 * Limites de tamanho (RFC 5321):
 *  - endereço completo: 254 caracteres;
 *  - parte local: 64 caracteres;
 *  - domínio: 255 caracteres.
 *
 * IMPORTANTE: esta expressão deve permanecer idêntica às validações do
 * aplicativo e da API para evitar comportamentos divergentes.
 */
const LOCAL = "[A-Za-z0-9!#$%&'*+\\-\\/=?^_`{|}~]+";
const LABEL = '[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?';

export const EMAIL_REGEX = new RegExp(
  `^${LOCAL}(?:\\.${LOCAL})*@(?:${LABEL}\\.)+[A-Za-z]{2,63}$`,
);

export const EMAIL_MAX_LENGTH = 254;
const LOCAL_MAX_LENGTH = 64;
const DOMAIN_MAX_LENGTH = 255;

export default function validaEmail(s: string): boolean {
  if (!s || s.length > EMAIL_MAX_LENGTH) return false;
  if (!EMAIL_REGEX.test(s)) return false;

  const arroba = s.lastIndexOf('@');
  const local = s.slice(0, arroba);
  const dominio = s.slice(arroba + 1);

  if (local.length > LOCAL_MAX_LENGTH) return false;
  if (dominio.length > DOMAIN_MAX_LENGTH) return false;

  return true;
}
